angular.module('bbl.module.dashboard.routing', [])
  .config(['$routeProvider', dashboardRoutingSetup]);

function dashboardRoutingSetup($routeProvider) {
  var resolveAuth = {
    userInfo: ["Auth", function(Auth) {
      return Auth.getUserInfo().catch(angular.noop);
    }], permissions: ["Auth", function(Auth) {
      return Auth.getPermission().then(function(response) {
        return response.data.permission_level;
      }).catch(angular.noop);
    }]
  };

  var dashboardRoute = {
    templateUrl: 'dashboard-template.html',
    controller: 'DashboardController',
    resolve: resolveAuth
  };

  $routeProvider.when('/dashboard/:addModal?', dashboardRoute);
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard.routing.js
 ** module id = 320
 ** module chunks = 0
 **/